import type { IconSvgObject } from './types';

const Tiff02Icon: IconSvgObject = [
  ["path", { d: "M19 22H5C3.89543 22 3 21.1046 3 20L3 4C3 2.89543 3.89543 2 5 2H12L19 9V11M18.5 9H13.998C12.8935 9 11.998 8.10457 11.998 7V2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.5 14H8M8 14H9.5M8 14V19M21 14H19V16.5M19 16.5V19M19 16.5H21M16.5 14H14.5V16.5M14.5 16.5V19M14.5 16.5H16.5M12 14V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Tiff02Icon;
